import { Directive, ElementRef, HostListener } from "@angular/core";
import Swal from "sweetalert2";

@Directive({
  selector: "[appMondayOnly]",
})
export class MondayOnlyDirective {
  constructor(private el: ElementRef) {}

  @HostListener("input", ["$event"]) onInput(event: Event): void {
    const inputDate = new Date((event.target as HTMLInputElement).value);
    if (inputDate.getDay() !== 1) {
      // Check if selected date is not Monday
      this.resetInput();
      this.showAlert();
    }
  }

  private resetInput(): void {
    (this.el.nativeElement as HTMLInputElement).value = "";
  }

  private showAlert(): void {
    Swal.fire({
      // icon: "error",
      title: "Invalid Selection",
      text: "Please select a Monday.",
      confirmButtonText: "OK",
    });
  }
}
